(ns frontend.ui.component.lp-portal.report.tearsheet.portfolio-by-country-at-fair-value.controller
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.chart.utils :as chart-utils]))

(defn portfolio-by-country-at-fair-value
  [portfolio-by-country-at-fair-value]
  (let [title "Portfolio by country at fair value"
        ;; TODO refactor `->array-of-tuple` to work without requiring the trailing keyword
        data (->> (util/->array-of-tuples portfolio-by-country-at-fair-value :country)
                  (keep (fn [[country pct]]
                          (when (> pct 0)
                            [(str country) pct])))
                  (sort-by (fn [[_ pct]]
                             pct)))]
    (donut-chart/donut-chart-config data
                                    {:data-label-formatter
                                     chart-utils/pie-%-label-formatter-no-division})))